type PromiseResolvers<T> = {
  resolve: (data: T) => void;
  reject: (error: any) => void;
};

export const deduplicateRequest = <T>(request: () => Promise<T>) => {
  let waitingForResults: PromiseResolvers<T>[] = [];
  let isAsyncWorking = false;
  return async () => {
    const promise = new Promise((resolve, reject) => {
      waitingForResults.push({ resolve, reject });
    });
    if (!isAsyncWorking) {
      try {
        isAsyncWorking = true;
        const token = await request();
        waitingForResults.forEach(({ resolve }) => {
          resolve(token);
        });
      } catch (error) {
        waitingForResults.forEach(({ reject }) => {
          reject(error);
        });
      } finally {
        isAsyncWorking = false;
        waitingForResults = [];
      }
    }
    return promise;
  };
};
